import { getBaseUrl } from "./Utils";
// import React from 'react';
// import { useUpdateVisualUnitConfigMutation } from './Redux/VisualUnits/visualUnitSlice';

// export const doExpColVisualUnit = async (vuId: number, expCol: boolean): Promise<void> => {

//     try {
//         const [updateVisualUnitConfig] = useUpdateVisualUnitConfigMutation();
//         const response = await updateVisualUnitConfig({ vuId, Expanded: expCol }).unwrap();
//         const lastRefreshedTime = document.getElementById(`table-last-refreshed-time_${vuId}`);

//         if (response && response.statusCode === 200) {
//             const vuDataObj = document.getElementById(`dashboard_vu_${vuId}`);

//             if (expCol) {
//                 document.getElementById(`dashboard_vu_data_${vuId}`)?.classList.remove('hide');

//                 const expandLink = document.getElementById(`link_dashboard_vu_expand_${vuId}`);
//                 const collapseLink = document.getElementById(`link_dashboard_vu_collapse_${vuId}`);
//                 const chartSettingList = document.getElementById(`vu-chart-setting-list-${vuId}`);

//                 if (expandLink) expandLink.style.display = 'none';
//                 if (collapseLink) collapseLink.style.display = 'block';
//                 if (chartSettingList) chartSettingList.style.display = 'block';

//                 if (vuDataObj?.getAttribute('data-vuDetails') === 'Non-autorefresh') {
//                     if(lastRefreshedTime) lastRefreshedTime.style.display = 'none';
//                 } else {
//                     if(lastRefreshedTime) lastRefreshedTime.style.display = 'block';
//                 }

//                 vuDataObj?.setAttribute('data-IsExpandedVisible', 'yes');
//             } else {
//                 document.getElementById(`dashboard_vu_data_${vuId}`)?.classList.add('hide');

//                 const expandLink = document.getElementById(`link_dashboard_vu_expand_${vuId}`);
//                 const collapseLink = document.getElementById(`link_dashboard_vu_collapse_${vuId}`);
//                 const chartSettingList = document.getElementById(`vu-chart-setting-list-${vuId}`);

//                 if (expandLink) expandLink.style.display = 'block';
//                 if (collapseLink) collapseLink.style.display = 'none';
//                 if (chartSettingList) chartSettingList.style.display = 'none';
//                 if(lastRefreshedTime) lastRefreshedTime.style.display = 'none';

//                 vuDataObj?.setAttribute('data-IsExpandedVisible', 'no');
//             }
//         }
//     } catch (error) {
//         console.error("Failed to update visual unit configuration:", error);
//     }
// };

// export default doExpColVisualUnit;

import forge from "node-forge";
import Cookies from "js-cookie";
import { FoundationsConstants } from './FoundationsConstants'
import { useSelector } from "react-redux";
import store, { getCurrentUserData, RootState } from "./Redux/store";
import { useNavigate } from "react-router-dom";
import { useInterval } from "usehooks-ts";
import { setUserToken } from "./Redux/User/userSlice";

// Global method for enforcing number and duration input only
export const forceNumberAndDurationOnly = (e: React.KeyboardEvent<HTMLInputElement>) => {
  const allowedKeys = [
    8, 9, 46, 190, 110, // Backspace, Tab, Delete, Period, Numpad Decimal
    16, 58, 59, 186, 187, // Shift, Colon, Semicolon, Equal
    83, 68, 72, 77, // S, D, H, M (duration characters)
    ...Array.from({ length: 4 }, (_, i) => 37 + i), // Arrow keys (left, up, right, down)
    ...Array.from({ length: 10 }, (_, i) => 48 + i), // Numbers 0-9
    ...Array.from({ length: 10 }, (_, i) => 96 + i), // Keypad numbers 0-9
  ];

  const key = e.charCode || e.keyCode || 0;

  // Prevent default behavior if the key is not allowed
  if (!allowedKeys.includes(key)) {
    e.preventDefault();
  }
};

export const encryptData = (data: string, pemPublicKey: string): string => {
  const publicKey = forge.pki.publicKeyFromPem(pemPublicKey);
  const encrypted = publicKey.encrypt(data, "RSAES-PKCS1-V1_5"); // PKCS#1 v1.5 padding
  return forge.util.encode64(encrypted);
}

export const setCookie = (name: string, value: string, expirationIntervalInSec: number) => {

  const baseURL = getBaseUrl();
  const url = new URL(baseURL);
  const domain = url.hostname;

  const expirationTime = new Date(new Date().getTime() + expirationIntervalInSec * 1000);
  Cookies.set(name, value, {
    expires: expirationTime,
    path: getCurrentCookiePath(),
    domain: domain
  });
}
export const getCurrentCookiePath = () => {
  let p = new URL(getBaseUrl()).toString().replace(new URL(window.location.origin).toString(), "/");
  var nPath = p.replace(/\/\//g, "/");
  do {
    p = nPath;
    nPath = nPath.replace(/\/\//g, "/");
  } while (nPath != p);
  nPath = nPath.replace(/\/$/, "");
  if (!nPath) nPath = "/";
  return nPath;
}

export const setHLUserCookies = (token: any, tokenExpirationIntervalInMin: number) => {
  const expirationTime = new Date(new Date().getTime() + tokenExpirationIntervalInMin * 1000)
  store.dispatch(setUserToken(token))
  // dispatch(setUserToken(token));
  setCookie(FoundationsConstants.TOKEN_STR, token, tokenExpirationIntervalInMin * 60);
  const formattedExpirationTime = expirationTime.toLocaleString('en-GB', {
    timeZone: 'UTC',
    weekday: 'short',
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false, // optional: for 24-hour format
  }).replace(/,/g, '').replace(/\s+/g, '-'); // e.g., Thu-19-Jun-2025-10:45:00

  const expirationTimeStr = `${formattedExpirationTime}-GMT`;


  setCookie(FoundationsConstants.TOKEN_EXP_STR, expirationTimeStr, tokenExpirationIntervalInMin * 60);
  //  Cookies.remove('name', { path: '/', domain: '.yourdomain.com' })
}

export const cleanHLUserCookies = () => {
  // Remove authentication-related cookies
  const baseURL = getBaseUrl();
  const url = new URL(baseURL);
  const domain = url.hostname;
  Cookies.remove(FoundationsConstants.TOKEN_EXP_STR, { path: getCurrentCookiePath(), domain: domain });
  Cookies.remove(FoundationsConstants.TOKEN_STR, { path: getCurrentCookiePath(), domain: domain });
}

export const redirectHome = (currentUserData: any) => {

  if (currentUserData.UserFavWorkspace == 'home') {
    return "#home"
  }
  else {
    return `#workspace/${currentUserData.UserFavWorkspace}`
  }
}


export const checkUserPrivileges = (currentUserData: any, privilegeName: string) => {
  if (!currentUserData)
    return false;

  const privileges = currentUserData.privileges;

  return privileges.indexOf(privilegeName) == -1 ? false : true;
}

export const startProxyCheckThread = (isProxyMode: boolean) => {
  const TriggerIntervalValue = isProxyMode ? 5 * 1000 : null;
  if(!isProxyMode){
    Cookies.remove(FoundationsConstants.PROXY_USER)
  }
  useInterval(() => {
    const TriggerProxyCookieExpirationValue = 5 * 60000;
    if (isProxyMode) {
      setCookie(FoundationsConstants.PROXY_USER, String(isProxyMode), TriggerProxyCookieExpirationValue)
    }
  }, (TriggerIntervalValue))
  return true
}

export const checkType1 = (currentUserData :any) => {
  
  if (currentUserData.type == 'SystemAdmin') {
    return true;
  }
  return false;
}

export  const  checkType1OrHasPrivilege = (currentUserData:any, privilege:string) => {
  if (checkType1(currentUserData))
    return true;
  return (
    checkUserPrivileges(currentUserData,privilege)
  );
}

export const adjustColor = (color: string, amount: number): string => {
  if (color && color !== "none") {
      if (color.startsWith("rgb")) {
          return color.replace(/\d{2,3}/g, (match) => 
              Math.min(255, Math.max(0, Math.round(parseInt(match) * amount))).toString()
          );
      } else {
          if (!color.startsWith("#")) {
              color = colorNameToHex(color);
          }
          return "#" + color.replace(/^#/, "").replace(/../g, (match) => 
              ("0" + Math.min(255, Math.max(0, Math.round(parseInt(match, 16) * amount))).toString(16)).slice(-2)
          );
      }
  } else {
      return "rgba(0,0,0,0)";
  }
};

export const onEnter = (e: React.KeyboardEvent<HTMLInputElement>, callback: () => void) => {
  if (e.key === 'Enter') {
      callback();
  }
};

const colorNameToHex = (colour: string): string => {
  const colours: Record<string, string> = {
      aliceblue: "#f0f8ff", antiquewhite: "#faebd7", aqua: "#00ffff", aquamarine: "#7fffd4", azure: "#f0ffff",
      beige: "#f5f5dc", bisque: "#ffe4c4", black: "#000000", blanchedalmond: "#ffebcd", blue: "#0000ff",
      blueviolet: "#8a2be2", brown: "#a52a2a", burlywood: "#deb887", cadetblue: "#5f9ea0", chartreuse: "#7fff00",
      chocolate: "#d2691e", coral: "#ff7f50", cornflowerblue: "#6495ed", cornsilk: "#fff8dc", crimson: "#dc143c",
      cyan: "#00ffff", darkblue: "#00008b", darkcyan: "#008b8b", darkgoldenrod: "#b8860b", darkgray: "#a9a9a9",
      darkgreen: "#006400", darkkhaki: "#bdb76b", darkmagenta: "#8b008b", darkolivegreen: "#556b2f", darkorange: "#ff8c00",
      darkorchid: "#9932cc", darkred: "#8b0000", darksalmon: "#e9967a", darkseagreen: "#8fbc8f", darkslateblue: "#483d8b",
      darkslategray: "#2f4f4f", darkturquoise: "#00ced1", darkviolet: "#9400d3", deeppink: "#ff1493", deepskyblue: "#00bfff",
      dimgray: "#696969", dodgerblue: "#1e90ff", firebrick: "#b22222", floralwhite: "#fffaf0", forestgreen: "#228b22",
      fuchsia: "#ff00ff", gainsboro: "#dcdcdc", ghostwhite: "#f8f8ff", gold: "#ffd700", goldenrod: "#daa520",
      gray: "#808080", green: "#008000", greenyellow: "#adff2f", honeydew: "#f0fff0", hotpink: "#ff69b4",
      indianred: "#cd5c5c", indigo: "#4b0082", ivory: "#fffff0", khaki: "#f0e68c", lavender: "#e6e6fa",
      lavenderblush: "#fff0f5", lawngreen: "#7cfc00", lemonchiffon: "#fffacd", lightblue: "#add8e6", lightcoral: "#f08080",
      lightcyan: "#e0ffff", lightgoldenrodyellow: "#fafad2", lightgrey: "#d3d3d3", lightgreen: "#90ee90",
      lightpink: "#ffb6c1", lightsalmon: "#ffa07a", lightseagreen: "#20b2aa", lightskyblue: "#87cefa",
      lightslategray: "#778899", lightsteelblue: "#b0c4de", lightyellow: "#ffffe0", lime: "#00ff00", limegreen: "#32cd32",
      linen: "#faf0e6", magenta: "#ff00ff", maroon: "#800000", mediumaquamarine: "#66cdaa", mediumblue: "#0000cd",
      mediumorchid: "#ba55d3", mediumpurple: "#9370d8", mediumseagreen: "#3cb371", mediumslateblue: "#7b68ee",
      mediumspringgreen: "#00fa9a", mediumturquoise: "#48d1cc", mediumvioletred: "#c71585", midnightblue: "#191970",
      mintcream: "#f5fffa", mistyrose: "#ffe4e1", moccasin: "#ffe4b5", navajowhite: "#ffdead", navy: "#000080",
      oldlace: "#fdf5e6", olive: "#808000", olivedrab: "#6b8e23", orange: "#ffa500", orangered: "#ff4500",
      orchid: "#da70d6", palegoldenrod: "#eee8aa", palegreen: "#98fb98", paleturquoise: "#afeeee",
      palevioletred: "#d87093", papayawhip: "#ffefd5", peachpuff: "#ffdab9", peru: "#cd853f", pink: "#ffc0cb",
      plum: "#dda0dd", powderblue: "#b0e0e6", purple: "#800080", rebeccapurple: "#663399", red: "#ff0000",
      rosybrown: "#bc8f8f", royalblue: "#4169e1", saddlebrown: "#8b4513", salmon: "#fa8072", sandybrown: "#f4a460",
      seagreen: "#2e8b57", seashell: "#fff5ee", sienna: "#a0522d", silver: "#c0c0c0", skyblue: "#87ceeb",
      slateblue: "#6a5acd", slategray: "#708090", snow: "#fffafa", springgreen: "#00ff7f", steelblue: "#4682b4",
      tan: "#d2b48c", teal: "#008080", thistle: "#d8bfd8", tomato: "#ff6347", turquoise: "#40e0d0",
      violet: "#ee82ee", wheat: "#f5deb3", white: "#ffffff", whitesmoke: "#f5f5f5", yellow: "#ffff00",
      yellowgreen: "#9acd32"
  };

  return colours[colour.toLowerCase()] ?? "#ffffff";
};
